import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const PersonCamera = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="169" viewBox="0 0 126 169" width="126" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M62.6 168.28c34.3 0 62.1-3.82 62.1-8.53s-27.8-8.53-62.1-8.53S.5 155.04.5 159.75s27.8 8.53 62.1 8.53Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        d="M52.74 22.86s-4.14-1.35-4.36 1.59c-.17 2.31.85 6.98 1.29 8.87a1.07 1.07 0 0 0 2.11-.21l.2-5.33c.01-.36.2-.68.5-.87l1.38-.86c.48-.3.64-.92.38-1.41-.39-.73-.97-1.66-1.51-1.79z"
        fill={shades.black}
      />
      <path
        d="M82.23 26.23s4.33-.45 3.93 2.47c-.31 2.3-2.29 6.65-3.12 8.4a1.07 1.07 0 0 1-2.02-.64l.92-5.25c.06-.35-.06-.71-.31-.95l-1.17-1.13a1.06 1.06 0 0 1-.07-1.46c.53-.64 1.3-1.42 1.85-1.43z"
        fill={shades.black}
      />
      <path
        className={strokeStyle}
        d="M67.87 23.86c-4.39 2.38-9.62 3.58-15.86 3.36q-.26-1.4-.26-2.87v-.19a15.5 15.5 0 0 1 1.68-6.89s2.87-2.62 8.84-3.3a28 28 0 0 0 4.27 8.33q.63.82 1.33 1.57z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M83.15 24.34a16 16 0 0 1-1.31 6.29c-6-.79-10.58-3.13-13.97-6.77q-.7-.76-1.33-1.57a28 28 0 0 1-4.27-8.33c1.65-.19 3.55-.23 5.69-.02 5.05.49 8.76 2.22 11.33 3.98a20 20 0 0 1 3.48 3q.38 1.66.38 3.43z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M81.84 30.63a16 16 0 0 1-2.04 3.4q-.75-.18-1.49-.4a29 29 0 0 1-10.45-5.85 36 36 0 0 1-15.2 1.86q-.42-1.18-.66-2.43c6.24.22 11.47-.98 15.86-3.35 3.39 3.64 7.97 5.98 13.97 6.77z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M79.81 34.03a15.71 15.71 0 0 1-27.13-4.39c5.02.39 10.08-.01 15.2-1.86a28.6 28.6 0 0 0 11.94 6.25z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M82.78 20.92a21 21 0 0 0-3.48-3 24 24 0 0 0-11.33-3.98 27 27 0 0 0-5.69.02c-5.97.68-8.84 3.3-8.84 3.3a15.7 15.7 0 0 1 29.35 3.65z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M79.63 14.44a15.72 15.72 0 0 0-26.83 4.25c-.01-.17-.89-14.12 4.59-16.58 5.52-2.48 18.09-2.19 20.89 1.7.62.86 1 2.12 1.21 3.57a34 34 0 0 1 .13 7.07z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M82.78 27.79a15.6 15.6 0 0 0-3.15-13.35 34 34 0 0 0-.13-7.07c4.79 4.37 7 10.44 3.27 20.42z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M74.79 50.66c-.28 1.76-3.83 3.16-8.18 3.16h-.16c-4.45-.03-8.04-1.53-8.04-3.38q0-.45.27-.86a22 22 0 0 1 8.52-.88q3.97.38 7.59 1.96Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M95.4 157.36H27.51c-14.45 0-24.79-13.33-20.5-26.47 8.18-25.04 21.98-59.39 39.85-74.56a37 37 0 0 1 7.81-5.19 27 27 0 0 1 4-1.56q-.27.42-.27.86c0 1.84 3.59 3.34 8.04 3.38h.16c4.35 0 7.91-1.39 8.18-3.15a34 34 0 0 1 10.41 7.3 62 62 0 0 1 8.35 10.57c5.73 8.94 10.4 20.03 14.17 31.39s6.64 23 8.74 33.04c2.64 12.62-7.53 24.39-21.05 24.39Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        d="m93.54 68.54-.11.29-.18.46-.25.63a110 110 0 0 1-2 4.7c-5.39 11.95-14.4 27.39-22.32 39.81l-6.18.43c.32-.48 1.51-3.05 3.2-6.9a830 830 0 0 0 13.23-32.08c2.69-6.97 4.97-13.32 6.11-17.43l.13-.49a62 62 0 0 1 8.35 10.57z"
        fill={shades.primary.medium}
      />
      <path
        d="m62.51 114.87-5.37.54c-2.42-6.52-4.58-14.59-6.28-23.05-2.46-12.17-3.98-25.12-3.99-35.32v-.69a37 37 0 0 1 7.8-5.19l-.03.36c-.96 10.9 1.06 29.99 5.16 50.71v.05c.18.92.69 3.27 1.21 5.71h-.04q.73 3.44 1.53 6.9z"
        fill={shades.primary.medium}
      />
      <path
        className={strokeStyle}
        d="M95.4 157.36H27.51c-14.45 0-24.79-13.33-20.5-26.47 8.18-25.04 21.98-59.39 39.85-74.56a37 37 0 0 1 7.81-5.19 27 27 0 0 1 4-1.56q-.27.42-.27.86c0 1.84 3.59 3.34 8.04 3.38h.16c4.35 0 7.91-1.39 8.18-3.15a34 34 0 0 1 10.41 7.3 62 62 0 0 1 8.35 10.57c5.73 8.94 10.4 20.03 14.17 31.39s6.64 23 8.74 33.04c2.64 12.62-7.53 24.39-21.05 24.39Z"
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M50.72 34.14c1.23 6.1 8.6 42.6 14.61 44.45" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M81.85 37.69s-3.52 12.45-6.63 18c-3.72 6.65-7.27 12.55-9.89 22.9-2.72 10.75-2.81 36.28-2.81 36.28"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M26.91 100.26c-4.56-.36-23.21 13.2-24.16 30.53s16.26 35.37 32.83 27.5 14.86-56.18-8.66-58.03z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M38.5 148.27c7.48-4.32 9.46-14.9 4.42-23.62-5.03-8.72-15.18-12.3-22.66-7.97-7.48 4.31-9.46 14.89-4.43 23.61 5.04 8.73 15.19 12.3 22.67 7.98Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M111.78 111.23c13.53 7.46 16.92 37.47.35 45.34-16.56 7.87-31.73-22.35-31.73-32.34s17.85-20.46 31.38-13Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M98.52 157.03c7.48-4.31 9.46-14.89 4.43-23.61-5.04-8.73-15.19-12.3-22.67-7.98s-9.46 14.9-4.42 23.62c5.03 8.72 15.18 12.3 22.66 7.97Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M55.82 112.27c-3.22 1.26-7.3 1.91-8.95.51l.38-5.01a4 4 0 0 0-3.86-3h-1.8a7.3 7.3 0 0 0 3.82-4.8c1.25-.56 3-1.13 4.86-1.1a4.3 4.3 0 0 0 .86 4.61c2.08 2.43 5.48 1.77 6.02-.56a7.75 7.75 0 0 1-1.33 9.37z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m45.42 99.96-.11.45a7.4 7.4 0 0 1-3.71 4.35h-2.19c-.66 0-1.24.44-1.42 1.07l-.55 1.93.32 8.69-1.62-4.13c-.59.07.45 4.34-.09 4.54-.52-1-2.9-6.05-3.96-6.82-2.09-1.54-11.27-5.8-18.12-4.38-.45-1.97-1.01-6.64 2.46-10.61 4.53-5.18 11.08-8.62 18.57-6.72q1.56.4 2.93 1.01a9.3 9.3 0 0 0-2.23 4.04c-.73 2.67-.14 5.83 4.28 5.55 3.21-.2 4.58-1.58 4.51-3.95a7.2 7.2 0 0 1 .94 4.97z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M86.58 116.05a14 14 0 0 0-3.68-.48q-2.97.02-5.43.8c-2.18.09-4.19-.88-4.82-3.85.68-2.02 2.36-5.71 5.68-6.36 2.11-.41 4.22.91 5.11 4.52.56 2.29 1.9 4.2 3.14 5.36z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="M78.33 124.62v26.56H63.42a16.1 16.1 0 0 0-.9-26.56z" fill={shades.white} />
      <path
        d="M78.32 151.18v5.61a7.6 7.6 0 0 1-7.61 7.35h-33.7a7.6 7.6 0 0 1-7.62-7.62v-5.35h14.9a16 16 0 0 0 9.56 3.15 16 16 0 0 0 9.56-3.15z"
        fill={shades.white}
      />
      <path className={strokeStyle} d="M47.25 107.77h-9.83l.86-3h8.21z" fill={shades.white} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M48.39 112.27H37.01q-.45 0-.88.05l1.31-4.56h9.82z" fill={shades.white} strokeWidth={strokeWidth} />
      <path d="M69.83 122.1a2.82 2.82 0 1 0 0-5.64 2.82 2.82 0 0 0 0 5.64Z" fill={shades.white} />
      <path
        d="M78.33 119.89v4.73H62.52a16.1 16.1 0 0 0-17.32 0H29.39v-4.73a7.6 7.6 0 0 1 7.62-7.62h33.71a7.6 7.6 0 0 1 7.62 7.62z"
        fill={shades.white}
      />
      <path d="M44.29 151.18h-14.9v-26.56H45.2a16.1 16.1 0 0 0-.9 26.56z" fill={shades.white} />
      <path
        d="m45.89 117.91-.18 2.14c-.06.7-.64 1.23-1.34 1.23h-9.01c-.79 0-1.4-.67-1.34-1.45l.18-2.14c.06-.7.64-1.23 1.34-1.23h9.01c.79 0 1.4.67 1.34 1.45Z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M62.51 124.62a16 16 0 0 0-8.66-2.52 16.1 16.1 0 0 0-9.56 29.08 16 16 0 0 0 9.56 3.15 16.1 16.1 0 0 0 8.66-29.71Zm-8.66 25.17a11.57 11.57 0 1 1-.01-23.15 11.57 11.57 0 0 1 .01 23.15Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M53.85 126.63a11.58 11.58 0 1 0 0 23.16 11.58 11.58 0 0 0 0-23.16Zm0 14.89a3.3 3.3 0 1 1 0-6.62 3.3 3.3 0 0 1 0 6.62Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M57.17 138.21a3.3 3.3 0 1 1-6.62 0 3.3 3.3 0 0 1 6.62 0Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M97 164.15h-4.01a18 18 0 0 1-5.69-3.76c-2.26 1.61-6.18 3.76-10.92 3.76q-1.47-.01-2.45-.72c-2.19-1.56-2.34-5.44.3-9.41-.1 1.65.2 3.68 2.14 4.06q1.01.17 1.83-.22c2.46-1.17 3.3-5.67.12-7.03a4 4 0 0 0-.99-.29l.06-.05.76-.65a10 10 0 0 1-3.56.65c-3.46-.1-7.21-3.18-4.63-8.96q.65-1.45 1.46-2.68c-.43 2.25-.34 4.68 1.97 4.94a5 5 0 0 0 4.93-2.3 4.8 4.8 0 0 0 0-5.57 5.4 5.4 0 0 0-1.94-2.05 18 18 0 0 1 2.15-1.2c5.06-2.39 10.69-2.21 13.94-1.01q3.16 1.16 5.77 3.65c3.92 3.71 6.79 9.55 8.01 17.08 1.77 10.95-9.26 11.77-9.26 11.77z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M78.32 149.69c6.63-5.52 12.59-7.66 17.28-4.31" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M87.3 160.39c1.34-.95 2.1-1.71 2.1-1.71" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M29.38 137.07a9 9 0 0 1-5.41 1.15c-7.8-.46-12.1-7.14-13.5-14.04-.67-3.28.39-5 1.68-5.91 2.39 3.2 5.89 5.03 7.95 5.91l.14.06c-.98 1.78-1.84 4.35-.26 6.34 2.7 3.4 6.04 1.69 7.02-.86a4.7 4.7 0 0 0-.32-4.03q1.53.05 2.71-.21.9-.2 1.52-.56c1.21 1.3 2.04 2.76 2.17 4.15.21 2.18-.52 6.06-3.7 7.99z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M98.25 135.3a17 17 0 0 0-5.77-3.65c-3.25-1.2-8.88-1.38-13.94 1.01l-.21.1a18 18 0 0 0-5.06 3.72q-.63.09-1.24.06a6.45 6.45 0 0 1-6.26-6.21c-.07-1.09.2-2.5.81-4.01.37 1.4 1.1 3 2.52 3.87 2.88 1.77 5.63-.44 5.11-4.24-.4-2.89-2.55-4.01-4.93-4.09a17.4 17.4 0 0 1 13.61-6.31q2 0 3.68.48c9.05 2.52 11.17 14.25 11.67 19.25z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M34.41 112.73a8 8 0 0 0-2.33-2.69c-2.09-1.54-11.27-5.8-18.12-4.38l-.65.15c-2.41.65-3.96 4.23-3.52 6.91a12.6 12.6 0 0 0 2.37 5.54c2.39 3.2 5.89 5.03 7.95 5.91l.14.06c2.2.92 4.48 1.39 6.44 1.46q1.53.05 2.71-.21.9-.2 1.52-.56c3.32-1.95 5.76-7.83 3.5-12.2zm-5.03 7.36q-.56.6-1.11.77c-2.22.65-6.2-1.85-5.91-5.21.28-3.36 3.7-4.95 6.99-3.95 1.47.45 2.06 1.61 2.11 2.96a8.4 8.4 0 0 1-2.08 5.43Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M27 129.72c-.98 2.54-4.32 4.26-7.02.86-1.58-1.99-.72-4.56.26-6.34 2.2.92 4.48 1.39 6.44 1.46a4.7 4.7 0 0 1 .32 4.03z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M29.38 120.09q-.56.6-1.11.77c-2.22.65-6.2-1.85-5.91-5.21.28-3.36 3.7-4.95 6.99-3.95 1.47.45 2.06 1.61 2.11 2.96a8.4 8.4 0 0 1-2.08 5.43Z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M39.96 98.94c-4.42.28-5.01-2.88-4.28-5.55a9 9 0 0 1 2.23-4.04 14 14 0 0 1 6.57 5.64c.06 2.37-1.3 3.75-4.51 3.95z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M47.25 107.77h-9.82l.55-1.93c.18-.63.76-1.07 1.42-1.07h5.94c.68 0 1.26.46 1.43 1.11z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M48.39 112.27H36.6l-.26.02-.12.01h-.1l1.31-4.56h9.82l1.14 4.51z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M36.19 112.32h-.07z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M57.15 102.9c-.53 2.34-3.94 3-6.02.56a4.3 4.3 0 0 1-.86-4.61q1.35.01 2.71.53c1.9.77 3.3 2.02 4.17 3.51z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M92.99 164.15H76.38c4.74 0 8.66-2.15 10.92-3.76a18 18 0 0 0 5.69 3.76Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M78.21 157.86c-.54.26-1.16.36-1.83.22-1.94-.38-2.24-2.41-2.14-4.06a18 18 0 0 1 3.1-3.49q.54.1.99.29c3.19 1.36 2.35 5.86-.12 7.03z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m78.32 149.69-.17.14" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M78.32 141.49a5 5 0 0 1-4.93 2.3c-2.31-.26-2.4-2.69-1.97-4.94a17 17 0 0 1 4.96-4.97 5.5 5.5 0 0 1 1.94 2.05q.31.53.58 1.15c.57 1.29.32 3.03-.58 4.42z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M69.11 130.21c-1.42-.87-2.15-2.47-2.52-3.87.59-1.45 1.48-3 2.7-4.46 2.38.08 4.54 1.2 4.93 4.09.52 3.8-2.22 6-5.11 4.24Z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m78.32 149.69-.17.14" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M37.98 105.84c-3.6.42-8.62-.57-15.34-4.22" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M114.23 62.54v-8.2" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M111.27 58.44h5.92" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M123.02 68.82c-.08.25 0 4.85 0 4.85" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M120.89 71.25h4.18" strokeWidth={strokeWidth} />
    </svg>
  );
};
